import { render, staticRenderFns } from "./MmmNavigationBackButton.vue?vue&type=template&id=dcabde48&"
import script from "./MmmNavigationBackButton.vue?vue&type=script&lang=js&"
export * from "./MmmNavigationBackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
